import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

let initialized = false;

export function initAmplitude() {
  if (initialized) return;

  const apiKey = window.chatwootConfig?.amplitudeKey;
  if (!apiKey) return;

  const storedDeviceId = localStorage.getItem('cw_amplitude_device_id');
  const deviceId =
    storedDeviceId ||
    (window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

  localStorage.setItem('cw_amplitude_device_id', deviceId);
  amplitude.setDeviceId(deviceId);

  amplitude.add(
    sessionReplayPlugin({
      sampleRate: 0.1,
      useWebWorker: true,
      privacyConfig: {
        defaultMaskLevel: 'medium',
      },
    })
  );

  amplitude.add(
    engagementPlugin({
      locale: window.chatwootConfig?.selectedLocale,
    })
  );

  amplitude.init(apiKey, {
    autocapture: {
      attribution: true,
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
      pageUrlEnrichment: true,
      elementInteractions: true,
      frustrationInteractions: true,
      webVitals: false,
    },
  });

  initialized = true;
}

export function trackEvent(name, props = {}) {
  if (!initialized) return;
  amplitude.track(name, props);
}

export function resetAmplitude() {
  amplitude.reset();
  initialized = false;
  localStorage.removeItem('cw_amplitude_device_id');
}

export function setAmplitudeUser(id) {
  amplitude.setUserId(id);
}
